<template>
  <div class="discount-switch-to-api">
    <div class="separator">
      <div class="line"></div>
      <div class="or">או</div>
      <div class="line"></div>
    </div>
    <template v-if="connectionType === 'דיסקונט'">
      <div class="text">
        <span class="bold">חיבור ישירות באמצעות אתר דיסקונט</span>
        (חיבור חשבון בנק משותף תלוי באישור הסניף ועלול לקחת מספר ימים)</div>
    </template>
    <template v-else>
      <div class="text">
        אפשר לחבר את החשבון באמצעות <span class="bold">פרטי המשתמש הקבועים</span>  שלך לאתר דיסקונט
      </div>
    </template>
    <div class="button-wrapper">
      <riseup-button :size="'small'" :variant="buttonVariant" :title="buttonText" :action="switchConnection"/>
    </div>
  </div>
</template>

<script>

import BaseUI from 'base-ui';
import SourceFields from '../../../mixins/SourceFields.vue';

export default {
  name: 'DiscountSwitchConnection',
  mixins: [SourceFields],
  props: {
    connectionType: {
      type: String,
      required: true,
    },
    switchConnection: {
      type: Function,
      required: true,
    },
  },
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  computed: {
    buttonVariant() {
      if (this.connectionType === 'דיסקונט') {
        return 'discount';
      }
      return 'primary';
    },
    buttonText() {
      if (this.connectionType === 'דיסקונט') {
        return 'חיבור דרך אתר דיסקנט';
      }
      return 'חיבור עם פרטי משתמש';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../scss/mixins';

  .discount-switch-to-api {
    font-family: SimplerPro;
    padding: 0 30px;

    .separator {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      color: $riseup_gray_2;
      margin-bottom: 25px;

      .line {
        height: 1px;
        width: 100%;
        background-color: $riseup_gray_1;
      }

      .or {
        color: $riseup_black;
        margin: 0 15px;
      }
    }

    .text {
      font-size: 18px;
      line-height: 1.44;
    }

    .bold {
      font-weight: bold;
    }

    .button-wrapper {
      @include responsive-padding-top-bottom;
      .riseup-button {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/onboarding/discount/DiscountSwitchConnection.vue